var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('symbol',{attrs:{"id":(_vm.prefix + "simple_plus"),"viewBox":"0 0 8 8"}},[_c('path',{attrs:{"fill":"#2DC3B7","d":"M5 0H3v3H0v2h3v3h2V5h3V3H5V0z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }